import request from '@/utils/request.js'

/*****批量修改过期时间列表******/
export function endtimeChgList(data){
    return request({
        url: 'sim/import/expire/list',
        method: 'post',
        data
    })
}
/*****批量修改过期时间列表******/
export function endtimeChg(data){
    return request({
        url: 'sim/update/expire/time',
        method: 'post',
        data
    })
}
/*****批量修改过期时间记录******/
export function endtimeChgRecordList(data){
    return request({
        url: 'sim/import/expire/info',
        method: 'post',
        data
    })
}
export function endtimeChgRecordList1(data){
    return request({
        url: 'sim/other/batch/upate/fail/list',
        method: 'post',
        data
    })
}

/***导入接口拿到data */
export function getImportDataQuery(data) {
    return request({
        url: 'sim/download/query',
        method: 'get',
        data
    })
}

/***查询即将过期的卡接口 */
export function getWillExpire(data) {
    return request({
        url: 'sim/queryExpiringSim',
        method: 'post',
        data
    })
}

/***查询已经过期的卡接口 */
export function getHasExpired(data) {
    return request({
        url: 'sim/queryAlreadyExpire',
        method: 'post',
        data
    })
}